// @flow
import React, { Component } from "react";
import ImagusFacePicker from "ImagusFacePicker";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { FaceDetectionResultType } from "../../types/FaceEyeTypes";
import type { EyeType } from "../../types/faceType";
import type { PanelStylesClassesType } from "../../../global/styles/generalStyles";
import { panelStyles } from "../../../global/styles/generalStyles";
import { LoadingProgress } from "imagus-components";
import SearchForm from "./SearchForm";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...panelStyles(theme),
  helpText: {
    color: theme.palette.primary.main,
    width: "100%",
    textAlign: "left",
    fontSize: "0.875rem",
    padding: "5px"
  }
});

type FaceDetectStatesType = {
  eyes: Array<EyeType> | null,
  selected: number | null
};

type FaceDetectLayoutClassesType = {
  ...PanelStylesClassesType,
  helpText: DictionaryType
};

type FaceDetectPropsType = {
  classes: FaceDetectLayoutClassesType,
  faceSearch: { [key: string]: * },
  tagList: string[],
  isV1Model: boolean,
  setDetectedFaces: Function,
  setCurrentFace: Function,
  setFaceSearchResult: Function,
  getTags: Function,
  setSearchedPerson: Function,
  searchByImage: Function,
  setStep: Function,
  setImageError: Function,
  ChipInput: React$ComponentType<*>
};

class FaceDetectLayout extends Component<
  FaceDetectPropsType,
  FaceDetectStatesType
> {
  constructor(props: FaceDetectPropsType) {
    super(props);
    this.state = {
      eyes: null,
      selected: null
    };
  }

  componentDidMount() {
    this.props.setImageError("");

    if (this.props.faceSearch.currentFace !== undefined) {
      this.props.setCurrentFace();
    }
    if (this.props.faceSearch.faceSearchResult !== undefined) {
      this.props.setFaceSearchResult();
    }
    this.props.setStep(1);

    if (this.props.faceSearch.detectedFaces) {
      let eyes = this.getEyesFromFaces(this.props.faceSearch.detectedFaces);
      this.setState({ eyes: eyes, selected: eyes.length > 0 ? 0 : null });
    }
  }

  componentDidUpdate(prevProps: FaceDetectPropsType) {
    if (
      this.props.faceSearch.detectedFaces !== prevProps.faceSearch.detectedFaces
    ) {
      let eyes = this.getEyesFromFaces(this.props.faceSearch.detectedFaces);
      if (eyes !== this.state.eyes) {
        this.setState({ eyes: eyes, selected: eyes.length > 0 ? 0 : null });
      }
    }
  }

  getEyesFromFaces = (
    faces: Array<FaceDetectionResultType>
  ): Array<EyeType> => {
    let eyes = faces.map((face: FaceDetectionResultType): EyeType => face.eyes);
    return eyes;
  };

  updateFaces = (faces: Array<EyeType>, selection: number) => {
    this.setState({ eyes: faces, selected: selection });
  };

  render(): * {
    const classes = this.props.classes;
    return (
      <div className={classes.appPanelContent}>
        {(this.props.faceSearch.loadedImage && this.state.eyes && (
          <Grid container spacing={24}>
            <Grid item xs={12} md={6}>
              <ImagusFacePicker
                faces={this.state.eyes}
                selection={this.state.selected}
                facesDidUpdate={this.updateFaces}
                imgUrl={this.props.faceSearch.loadedImage}
              />
              <Typography variant="caption" className={classes.helpText}>
                *Use the controls on the faces to properly align the eye
                positions.
                <br />
                *Click button to add or remove a face.
                <br />
                Apply filters to perform detection.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchForm
                eyes={this.state.eyes}
                selected={this.state.selected}
                setImageError={this.props.setImageError}
                setStep={this.props.setStep}
                faceSearch={this.props.faceSearch}
                tagList={this.props.tagList}
                isV1Model={this.props.isV1Model}
                getTags={this.props.getTags}
                setSearchedPerson={this.props.setSearchedPerson}
                searchByImage={this.props.searchByImage}
                ChipInput={this.props.ChipInput}
              />
            </Grid>
          </Grid>
        )) || <LoadingProgress />}
      </div>
    );
  }
}

export default withStyles(styles)(FaceDetectLayout);
